<template>
    <div class="product-page body-box">
        <div class="hero-header">
            <h3 class="title-with-dot">{{ headerTitle }}</h3>
        </div>

		<div class="product-content-body">
			<div class="product-content-body-inner">
					
				<h1>{{ sectionTitle }}</h1>
				<p>{{ sectionDescription }}</p>

            </div>

            <products-section />

            <news-letter />

            <ohilo-footer />
        </div>

    </div>
</template>

<script>
import ProductsSection from '@/components/sections/ProductsSection.vue';
import NewsLetter from '@/components/sections/NewsLetter.vue';
import OhiloFooter from '@/components/common/OhiloFooter.vue';

export default {
    name: 'ProductView',
    components: {
        ProductsSection,
        NewsLetter,
        OhiloFooter,
    },
    data() {
        return {
            headerTitle: 'Products',
            sectionTitle: 'Explore My Products',
            sectionDescription: 'Some of the digital products that I worked on as side projects, explore and try it now',
        }
    }
}
</script>